<template>
  <div class="fts-state" :style="{'background-color': model.color}" v-if="model.name">
    <div>{{model.name}}</div>
  </div>
</template>

<script>
export default {
  props: {
    stateId: String,
    state: Object,
    states: Array
  },
  computed: {
    model() {
      const state = { name: '(unset)', ...this.state};
      const states = Array.isArray(this.states) ? this.states : [];
      let stateId = null;

      if (this.stateId) {
        stateId = this.stateId;
      } else if (state && state.stateId) {
        stateId = state.stateId;
      } else if (state && state.id) {
        stateId = state.id;
      }

      if (states && states.length && stateId) {
        const res = states.find(x => x.id === stateId);
        if (res && res.id) {
          return { id: res.id, name: res.name, color: res.color};
        }
      }
      return state;
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-state {
  min-width: 1rem;
  max-width: 100%;
  display: inline-flex;
  border-radius: 0.25rem;
  background-color: var(--fts-default);
  cursor: default;
  > div {
    @include text-overflow-ellipsis;
    padding-left: 0.375rem;
    padding-right: 0.375rem;
    font-weight: var(--inistate-font-weight-medium);
    font-size: var(--inistate-label-text-14);
    line-height: var(--inistate-paragraph-text-14--line-height);
    color: var(--fts-light);
    cursor: inherit;
  }
  &.fts-state-md {
    > div {
      font-size: $comfort-font-size;
      line-height: $comfort-line-height;
    }
  }
}
</style>